import { __extends } from "tslib";
import { GroupSummaryDisplayMode_$type } from "./GroupSummaryDisplayMode";
import { IgrDefinitionBase } from "./igr-definition-base";
import { SectionHeader } from "./SectionHeader";
import { brushToString, stringToBrush, ensureBool, ensureEnum } from "igniteui-react-core";
/**
 * Used to configure the appearance of the section header cells.
*/
var IgrSectionHeader = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrSectionHeader, _super);
    function IgrSectionHeader(props) {
        return _super.call(this, props) || this;
    }
    IgrSectionHeader.prototype.createImplementation = function () {
        return new SectionHeader();
    };
    Object.defineProperty(IgrSectionHeader.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrSectionHeader.prototype, "selectedBackground", {
        get: function () {
            return brushToString(this.i.fe);
        },
        set: function (v) {
            this.i.fe = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrSectionHeader.prototype, "actualSelectedBackground", {
        get: function () {
            return brushToString(this.i.fd);
        },
        set: function (v) {
            this.i.fd = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrSectionHeader.prototype, "paddingLeft", {
        /**
         * Gets or sets the amount of left padding to use for the cell content for this column.
        */
        get: function () {
            return this.i.ex;
        },
        set: function (v) {
            this.i.ex = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrSectionHeader.prototype, "paddingTop", {
        /**
         * Gets or sets the amount of top padding to use for the cell content for this column.
        */
        get: function () {
            return this.i.ez;
        },
        set: function (v) {
            this.i.ez = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrSectionHeader.prototype, "paddingRight", {
        /**
         * Gets or sets the amount of right padding to use for the cell content of this column.
        */
        get: function () {
            return this.i.ey;
        },
        set: function (v) {
            this.i.ey = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrSectionHeader.prototype, "paddingBottom", {
        /**
         * Gets or sets the amount of bottom padding to use for the cell content of this column.
        */
        get: function () {
            return this.i.ew;
        },
        set: function (v) {
            this.i.ew = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrSectionHeader.prototype, "isCollapsable", {
        get: function () {
            return this.i.eq;
        },
        set: function (v) {
            this.i.eq = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrSectionHeader.prototype, "summaryDisplayMode", {
        get: function () {
            return this.i.en;
        },
        set: function (v) {
            this.i.en = ensureEnum(GroupSummaryDisplayMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    return IgrSectionHeader;
}(IgrDefinitionBase));
export { IgrSectionHeader };
//# sourceMappingURL=igr-section-header.js.map
